module.exports = __webpack_public_path__ + "static/loading-animation-b8cd4b1bb7fc797ca1d2d8cee7bd80c2.png";